<template lang="pug">
    div.separacion
      div(:class="{disablediv: !enableFileUpload}")
        vue-dropzone(
          v-show="showDropZone === true"
          ref="myDropzone"
          id="dropFU"
          :options='dropOptions'
          @vdropzone-success="afterSuccess"
          @vdropzone-error="OnError"
        )
        div(v-if="showDropZone === false")
          span {{name}}
          button.btn.btn-link(@click="deleteFile")
            i.fa(:class="'fa-trash'")
</template>
<script>
import vueDropzone from 'vue2-dropzone'

export default {
  name: 'FileUpload',
  components: { vueDropzone },
  // eslint-disable-next-line
  data () {
    return {
      showDropZone: true,
      name: ''
    }
  },
  props: {
    fileName: {
      type: String,
      default: ''
    },
    enableFileUpload: {
      type: Boolean,
      default: false
    },
    dropOptions:
    {
      type: Object,
      default: null
    }

  },
  watch: {
    // eslint-disable-next-line
    fileName () {
      this.checkName()
    },
    // eslint-disable-next-line
    enableFileUpload (value) {
      if (!value) {
        this.$refs.myDropzone.disable()
      } else {
        this.$refs.myDropzone.enable()
      }
    }

  },
  // eslint-disable-next-line
  mounted () {
    this.checkName()
  },
  computed: {
    // eslint-disable-next-line
    uploadUrl () {
      return process.env.VUE_APP_API_ENV === 'local'
        ? 'https://httpbin.org/post'
        : 'http://{{baseUrl}}/sobree/api/documentation/CO-PN-2019-2/48458081W'
    }
  },
  methods: {
    // eslint-disable-next-line
    checkName () {
      if (this.fileName === '') {
        this.$refs.myDropzone.removeAllFiles(true)
        this.showDropZone = true
      } else {
        this.showDropZone = false
        this.name = this.fileName
      }
    },
    // eslint-disable-next-line
    afterSuccess ($event) {
      this.name = $event.upload.filename
      this.showDropZone = false
      this.$emit('file-add-complete', $event.upload.filename)
    },
    // eslint-disable-next-line
    deleteFile () {
      this.$refs.myDropzone.removeAllFiles(true)
      this.name = ''
      this.showDropZone = true
      this.$emit('file-add-complete', this.name)
    },
    // eslint-disable-next-line
    OnError (file, message) {
      let parsedMessage = message
      if (message.data) {
        parsedMessage = this.$t('shared.fileUpload.' + message.data.message).toString()
      }
      if (message.message === 'dictBadExtension') {
        parsedMessage = this.$t('shared.fileUpload.' + message.message).toString()
      }
      this.$emit('fileupload-error', parsedMessage)
      this.$refs.myDropzone.removeAllFiles(true)
    }
  }
}
</script>
<style lang="scss" scoped>
  .vue-dropzone>.dz-preview .dz-details{
    display: none;
  }
  .disablediv{
    opacity: 0.4;
    cursor: not-allowed;
  }
  .marginsLeftRight20{
    margin-left: 20px;
    margin-right: 20px;
  }
  .alert-danger {
    margin: 8px 0;
  }
  .no-alert {
    display: none;
  }
</style>
